<div class="form-group mt-lg-0">
  <button (click)="loginTM()" class="btn btn-block border-0 btn-primary login-button font-size-14 w-100 fw-bold text-white">
    <span>{{ 'tm.login' | translate }}</span> <span><img src="/assets/images/ticketmaster.svg" class="tm-logo ps-2 mb-1" /></span>
  </button>
</div>

<div class="login-title-section">
  <fgbcl-errors></fgbcl-errors>
</div>
